import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['output'];

    connect() {
        this.timeLeft = 10 * 60; // 10 minutes in seconds
        this.startTimer();
    }

    startTimer() {
        this.timer = setInterval(() => {
            if (this.timeLeft <= 0) {
                clearInterval(this.timer);
                this.outputTarget.textContent = '00:00';
            } else {
                this.timeLeft -= 1;
                this.outputTarget.textContent = this.formatTime(this.timeLeft);
            }
        }, 1000);
    }

    formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }

    disconnect() {
        clearInterval(this.timer);
    }
}
